import React from "react";
import './styles.css'

const SubTextLabel = ({ label }) => {
    return (
        <div className='sub-text-label'>{label}</div>
    )
}

export default SubTextLabel